import React from 'react';
import PropTypes from 'prop-types';

import Destination from '../../propTypes/Destination';
import DestinationContext from './DestinationContext';

/**
 * @typedef {Object} DestinationProviderProps
 * @property {import('../../propTypes/Destination').Destination} value
 * @property {import('react').ReactNode} children
 */

/**
 * @param {DestinationProviderProps} props
 */
const DestinationProvider = ({ value, children }) => (
  <DestinationContext.Provider value={value}>
    {children}
  </DestinationContext.Provider>
);

DestinationProvider.propTypes = {
  value: PropTypes.shape(Destination).isRequired,
  children: PropTypes.node.isRequired,
};

export default DestinationProvider;
